export function BookmarkIcon({ isBookmarked }: { isBookmarked: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className="h-7 w-7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={isBookmarked ? "currentColor" : "none"}
    >
      <path d="M7 5.5h10v13l-5-3-5 3Z"></path>
    </svg>
  );
}
